import script from "./DeleteVideosModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteVideosModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteVideosModal.vue?vue&type=style&index=0&id=c22a33f2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c22a33f2"]])

export default __exports__